function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.2169 0.252294C12.3832 0.084097 12.5743 0 12.7904 0C13.0065 0 13.1976 0.084097 13.3638 0.252294C13.5134 0.40367 13.5882 0.592889 13.5882 0.819954C13.5882 1.04702 13.5134 1.23624 13.3638 1.38761L5.41036 9.48624L5.31063 9.58716C5.16104 9.75535 4.97404 9.83945 4.74965 9.83945C4.52526 9.83945 4.33826 9.75535 4.18867 9.58716L0.224393 5.60092C0.0747969 5.44954 0 5.26032 0 5.03326C0 4.80619 0.0747969 4.61697 0.224393 4.4656C0.390611 4.2974 0.581758 4.2133 0.797841 4.2133C1.01392 4.2133 1.20507 4.2974 1.37129 4.4656L4.73718 7.87156L12.2169 0.252294Z",
  transform: "translate(3.70587 5)"
});

var SvgChecked = function SvgChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "3.5 5 14 10",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checked.76126376.svg";
export { ForwardRef as ReactComponent };